import React, { memo, useCallback, useContext } from 'react'
import { Dropdown, Icon, SlideUp, Text } from 'common-components'
import { useDropdownState } from 'hooks/useDropdownState'
import { useMobileInnerSliderCallbacks } from 'hooks/useMobileInnerSliderCallbacks'
import { useResponsive } from 'hooks/useResponsive'
import { useEventListener } from 'hooks'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { ScrollableElementContext } from '../../contextApi'
import DropdownList from '../DropdownList'
import * as Styled from './styled'
import { IOption, IProps } from './types'

const HeaderContent = ({ activeOption }: { activeOption: IOption }) => {
  const { icon, label } = activeOption

  return (
    <Styled.HeaderContent>
      {!!icon && <Icon icon={icon} size="small" color="secondarySemiDark" />}
      <Text type="h2" color="secondarySemiDark">
        {label}
      </Text>
    </Styled.HeaderContent>
  )
}

const AspectRatioDropdown: React.FC<IProps> = ({
  options,
  activeOption,
  onOptionClick
}) => {
  const { openCallback, closeCallback } = useMobileInnerSliderCallbacks()
  const { scrollableElementRef } = useContext(ScrollableElementContext)
  const { isOpen, closeDropdown, toggleDropdown } = useDropdownState(
    openCallback,
    closeCallback
  )

  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  useEventListener(
    'scroll',
    () => !isTablet && closeDropdown(),
    scrollableElementRef?.current
  )

  const handleOptionClick = useCallback(
    (option: IOption) => {
      onOptionClick(option)
      closeDropdown()
    },
    [onOptionClick, closeDropdown]
  )

  if (isTablet && isOpen) {
    return (
      <SlideUp isOpen={isOpen} onClose={closeDropdown}>
        <DropdownList
          onItemClick={handleOptionClick}
          selectedItemKey={activeOption.key}
          data={options}
        />
      </SlideUp>
    )
  }

  return (
    <Dropdown
      headerContent={<HeaderContent activeOption={activeOption} />}
      mainContent={
        <DropdownList
          onItemClick={handleOptionClick}
          selectedItemKey={activeOption.key}
          data={options}
        />
      }
      isOpen={isOpen}
      toggleDropdown={toggleDropdown}
      closeDropdown={closeDropdown}
    />
  )
}

export default memo(AspectRatioDropdown)
